<template>
  <Card :padding="5"    dis-hover :bordered="false"  :style="'background:#eee;height:' + clientHeight +'px'">
    <div class="efutre-report" tabindex="0" @keydown.ctrl.shift.alt.65="downSql">
    <Card ref="toolbarcard" :padding="0" style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle"  style="padding:5px 10px" >
            <Col  span='18'>
               <ButtonToolBar  ref="menutoolbar" style="margin-left: -8px;" :config="menuToolbar"  :moduleMethod="moduleMethod" justify="start" @doAction="doAction"/>
            </Col>
            <Col span="6"  >
                <Row type="flex" justify="end" align="middle">
                    <PromptMessage/>
                </Row>
            </Col>
        </Row>
    </Card>
    <Card ref="formcard" :padding="0"  dis-hover :bordered="true"  style="margin-bottom: 5px;">
        <FormCardBox  ref="form"  :config="myConfig.formConfig" :dictData="dictData" @on-open-change="onOpenChange"/>
    </Card>
    <Card :padding="0" :bordered="false" dis-hover>
        <ViewGrid  ref="grid" :config="myConfig.gridConfig"  :dictData="dictData" />
    </Card>
    </div>
  </Card>
</template>

<script>
import PromptMessage from './promptmessage.vue';
import ButtonToolbar from './btntoolbar.vue';
export default {
    name:'report',
    components:{PromptMessage,ButtonToolbar},
    data () {
        return {
            myConfig:{
                titleType:2,
                divStyle:'padding:5px',
                title:'查询条件'
            },
            menuToolbar:{},
            gridToolbar:{},
            frontBtn: [{
                name:'searchData',text:'查询'
            },{
                name:'clearData',text:'清除'
            }]
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        },
        defaultExport: {
            type:Boolean,
            default:false
        } 

    },
    computed: {
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        this.myConfig.gridConfig.headStyle='';
        this.myConfig.gridConfig.showCondition = false;
        this.myConfig.gridConfig.onSelectionChange = this.gridOnSelectionChange;
        if (this.myConfig.gridConfig.resources === undefined) {
            this.myConfig.gridConfig.resources =this.config.resources;
        }
        if (this.myConfig.gridConfig.method === undefined) {
            this.myConfig.gridConfig.method = this.config.classPrefix + '.' +'query';
        }
        if (this.myConfig.gridConfig.response === undefined) {
            this.myConfig.gridConfig.response =  this.config.response;
        }
        this.myConfig.gridConfig.height = 1;
        this.myConfig.gridConfig.width = 1;
        this.myConfig.gridConfig.adjustHeight = 0;
        this.myConfig.gridConfig.adjustWidth = 0;
        
        if (this.myConfig.gridConfig.pageSizeNum === undefined) {
            this.myConfig.gridConfig.pageSizeNum = 20;
        }
        this.myConfig.gridConfig.items.forEach(el => {
            if (el.type !== 'CheckBox') {
                if (el.tooltip === undefined) {
                    el.tooltip = true;
                }
            }
        });
        this.myConfig.formConfig.titleType = this.myConfig.titleType;
        if (this.myConfig.formConfig.title === undefined) {
            this.myConfig.formConfig.title = this.myConfig.title;
        }
        this.myConfig.formConfig.divStyle = this.myConfig.divStyle;
        this.myConfig.formConfig.showBtn = false;
        this.myConfig.formConfig.hide = true;
        this.myConfig.formConfig.disHover = true;
        if (this.myConfig.menuToolbar && this.myConfig.menuToolbar.items) {
            this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);     
        } 
    },
    methods: {
        doMenuToolbar() {
            if (this.$refs.menutoolbar) {
                this.$refs.menutoolbar.addBtnObject(this.frontBtn,'front');
            }
        },
        doAction (obj) {
            const method = obj.name;
            if (this.$parent[method]) {
                this.$parent[method]();
            } else {
                if (this[method]) {
                    this[method]();
                }
            }
        },
        downSql() {
            this.$nextTick(() => {
                this.exportSql();
            });
            //console.log(1);
        },
        clearData () {
            this.$refs.form.clearData();
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.clearData();
        },
        searchData() {
            this.$refs.form.checkValidate();
            let flag = this.$refs.form.isError();
            if (flag) {
                this.alert('必填项不允许为空');
                return false;
            }
            let data = this.$refs.form.getData();
            let searchParam = {};
            for (let pro in data) {
                if (data[pro] || data[pro] === 0) {
                    searchParam[pro] = data[pro];
                }
            }
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.setSearchBeforeSearchParam(searchParam);
            this.$refs.grid.refurbish();
        },
        exportData() {
            let data = this.$refs.grid.getData();
            if (data.length  === 0) {
                this.alert('请先查询数据');
                return false;
            }
            if (this.myConfig.gridConfig.dynamicColumnFlag) {
                this.$refs.grid.dynamicExportExcel();
            } else {
                if (this.myConfig.defaultExport) {
                    let _param = this.$refs.grid.getSearchParam();
                    let  moduleCode = this.getModulecode();
                    if (moduleCode) {
                        _param.moduleCode = moduleCode;
                    } else {
                        this.alert('模块号不能为空');
                        return;
                    }
                    _param.exporttype = 'excel';
                    let _baseUrl = this.myConfig.gridConfig.resources.replace('rest', 'exportReport');
                    let  _self  = this;
                    this.doExportReport(_baseUrl, this.myConfig.gridConfig.method, _param, _self);
                } else {
                    this.$refs.grid.export();
                }
               
            }
        },
        exportSql() {
            let _param = this.$refs.grid.getSearchParam();
            let  moduleCode = this.getModulecode();
            if (moduleCode) {
                _param.moduleCode = moduleCode;
            } else {
                this.alert('模块号不能为空');
                return;
            }
            let data = this.$refs.form.getData();
            for (let pro in data) {
                if (data[pro] || data[pro] === 0) {
                    _param[pro] = data[pro];
                }
            }
            let _baseUrl = this.myConfig.gridConfig.resources.replace('rest', 'exportReportInfo');
            let  _self  = this;
            this.doExportReport(_baseUrl, this.config.classPrefix+'.getrptinfo', _param, _self);

        },
        refurbish () {
            this.searchData();
        },
        getGrid () {
            return this.$refs.grid;
        },
        getForm () {
            return this.$refs.form;
        },
        onOpenChange(value) {
            this.setGridHeight(value);
        },
        setGridHeight() {
            let height =  this.clientHeight -  this.$refs.toolbarcard.$el.clientHeight - this.$refs.formcard.$el.clientHeight;
            this.$refs.grid.setCalHeight(height);
        }
    },
    mounted () {
        this.doMenuToolbar();
        this.setGridHeight();
    }
};
</script>




// WEBPACK FOOTER //
// src/components/layouttemplate/report.vue